import unifyComponents from "../../helpers/components/unifyComponents";
import calculateQuantityAvailable from "../../helpers/components/calculateQuantityAvailable";

export default function stockMessageInputs({
  variant,
  quantityRequested,
  allocatedComponents = {},
}) {
  const quantityRequestedInt = parseInt(quantityRequested);
  const adjustedQuantityRequested = isFinite(quantityRequestedInt)
    ? quantityRequestedInt
    : 0;

  const unifiedComponents = unifyComponents({
    variant,
    components: variant.components,
    multiComponents: variant.multiComponents,
  });

  const { calculatedQuantityAvailable } = calculateQuantityAvailable({
    allocatedComponents,
    components: unifiedComponents,
    quantityAvailable: variant.quantityAvailable,
  });

  console.log(`unifiedComponents`, unifiedComponents);
  console.log(`calculatedQuantityAvailable`, calculatedQuantityAvailable);

  return {
    availableForSale: JSON.parse(variant.availableForSale),
    // Add 1 so messaging reflects state prior to adding the last item
    // instead of state after you make your purchase.
    // If there is 1 available, you want 1, then we should
    // show messaging for 1 available, not 0.
    quantityAvailable:
      calculatedQuantityAvailable - adjustedQuantityRequested + 1,
    lowStockThreshold: JSON.parse(variant.lowStockThreshold),
    dnr: JSON.parse(variant.dnr),
    cargoReady: JSON.parse(variant.cargoReady),
    backorderDate: variant.backorderDate,
  };
}
